import React, { useEffect, useRef, useState } from 'react';
import styled from "styled-components";
import { Col, Card, Row, Form, Skeleton, QRCode, Input, Button, Image, message, Typography, Tag } from "antd";
import axios from 'axios';
import errorImage from '../../../../escolhaservidor.webp';
import axiosInstance from '../../../../axiosInterceptor';
import InputMask from 'react-input-mask';

const { Title, Text } = Typography;

const Mensageiro = () => {
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");

  const [form] = Form.useForm();
  const intervalRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [loadingQR, setLoadingQR] = useState(false);
  const [loja, setLoja] = useState(null);
  const [idLoja, setIDLoja] = useState(null);

  const [telefoneBusca, setTelefoneBusca] = useState(null);
  const [qrCode, setQrCode] = useState('');
  const [instanciaInfo, setInstanciaInfo] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (idUser) {
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      axiosInstance.get(
        `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
        options
      ).then((resp) => {
        setIDLoja(resp.data.id);
        setLoja(resp.data);
      });
    }
  }, [idUser, accessToken]);

  useEffect(() => {
    if (!telefoneBusca) return;

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      buscarQrPorTelefone(telefoneBusca, true);
    }, 5000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [telefoneBusca]);

  function somenteNumeros(value) {
    return (value || '').replace(/\D/g, '');
  }

  function formatarTelefone(phoneNumber) {
    if (!phoneNumber) return '';

    const cleaned = phoneNumber.replace(/\D/g, '');

    if (cleaned.startsWith('55') && (cleaned.length === 12 || cleaned.length === 13)) {
      const numberWithoutCountryCode = cleaned.substring(2);

      if (numberWithoutCountryCode.length === 11) {
        return numberWithoutCountryCode.replace(/^(\d{2})(\d{5})(\d{4})$/, '+55 ($1) $2-$3');
      }

      if (numberWithoutCountryCode.length === 10) {
        return numberWithoutCountryCode.replace(/^(\d{2})(\d{4})(\d{4})$/, '+55 ($1) $2-$3');
      }
    }

    return phoneNumber;
  }

  function normalizarTelefoneDigitado(telefone) {
    let whatsappApenasNumeros = somenteNumeros(telefone);

    const regexTelefone = /^[1-9]{2}\d{8}$/;
    const regexCelular = /^[1-9]{2}9\d{8}$/;

    if (!regexTelefone.test(whatsappApenasNumeros) && !regexCelular.test(whatsappApenasNumeros)) {
      return null;
    }

    return `55${whatsappApenasNumeros}`;
  }

  function extrairQrCode(data) {
    return (
      data?.qrcode ||
      data?.qrCode ||
      data?.base64 ||
      data?.qrcodeString?.qr ||
      data?.qrcode?.base64 ||
      data?.qrcode?.qr ||
      ''
    );
  }

  function extrairStatus(data) {
    return (
      data?.status ||
      data?.state ||
      data?.connectionStatus ||
      data?.instance?.status ||
      data?.instance?.state ||
      null
    );
  }

  function estaConectado(data) {
    const statusAtual = `${extrairStatus(data) || ''}`.toLowerCase();

    return (
      statusAtual.includes('open') ||
      statusAtual.includes('connected') ||
      statusAtual.includes('conectado') ||
      !!data?.owner ||
      !!data?.number ||
      !!data?.profileName ||
      !!data?.instance?.owner ||
      !!data?.instance?.profileName
    );
  }

  async function buscarQrPorTelefone(telefoneCompleto, silencioso = false) {
    if (!accessToken) return;

    try {
      if (!silencioso) {
        setLoading(true);
      }

      setLoadingQR(true);

      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      /**
       * Crie esse endpoint no seu backend.
       * Ele deve:
       * 1. receber o telefone;
       * 2. procurar a instância correspondente;
       * 3. retornar QR se estiver pendente;
       * 4. retornar status/dados se já estiver conectado.
       */

      const response = await axios.get(
        `https://apimsg.techsbot.com.br/whatsapp/qrcode-por-telefone/${telefoneCompleto}`,
        {
          params: {
            nomeLoja: loja?.nome,
            idLoja: idLoja,
          },
        }
      );

      const data = response.data;

      console.log('[QR POR TELEFONE]', data);

      const qr = extrairQrCode(data);
      const statusAtual = extrairStatus(data);

      setQrCode(qr);
      setStatus(statusAtual);
      setInstanciaInfo(data);

      if (estaConectado(data)) {
        setQrCode('');

        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      }

    } catch (error) {
      console.error(error);

      if (!silencioso) {
        message.error(error?.response?.data?.erro || error?.response?.data || 'Não foi possível buscar o QR Code.');
      }

      setQrCode('');
      setInstanciaInfo(null);
      setStatus(null);
    } finally {
      setLoading(false);
      setLoadingQR(false);
    }
  }

  async function onFinish(dados) {
    const telefoneCompleto = normalizarTelefoneDigitado(dados.whatsapp);

    if (!telefoneCompleto) {
      message.info('Número inválido. Verifique se digitou corretamente.');
      return;
    }

    setTelefoneBusca(telefoneCompleto);
    await buscarQrPorTelefone(telefoneCompleto);
  }

  const conectado = instanciaInfo && estaConectado(instanciaInfo);

  return (
    <Container>
      <Row
        gutter={16}
        style={{
          justifyContent: "center",
          marginTop: "70px",
          marginBottom: "80px",
          width: '100%',
        }}
      >
        <Card style={{ width: "95%", margin: "0 auto", padding: "20px" }}>
          <Title level={4}>Conectar WhatsApp</Title>

          <Text type="secondary">
            Digite o número autorizado para localizar o QR Code da instância.
          </Text>

          <Form
            form={form}
            name="mensageiro-qrcode"
            layout="vertical"
            style={{ marginTop: 20 }}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Col>
              <Form.Item
                label="WhatsApp"
                name="whatsapp"
                rules={[{ required: true, message: 'Whatsapp obrigatório!' }]}
                style={{ width: '100%' }}
              >
                <InputMask mask="(99) 99999-9999">
                  {(inputProps) => (
                    <Input
                      {...inputProps}
                      style={{ width: '100%' }}
                      placeholder="(11) 99999-9999"
                    />
                  )}
                </InputMask>
              </Form.Item>

              <Button
                style={{ width: '100%', backgroundColor: '#000' }}
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Buscar QR Code
              </Button>
            </Col>
          </Form>
        </Card>

        <Card style={{ width: "95%", margin: "10px auto 0", padding: "20px" }}>
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} style={{ textAlign: "center" }}>
              {loading && !instanciaInfo ? (
                <Skeleton active />
              ) : conectado ? (
                <div>
                  <Title level={4}>WhatsApp conectado</Title>

                  <Tag color="green">Conectado</Tag>

                  <div style={{ marginTop: 16 }}>
                    <strong>Número conectado: </strong>
                    {formatarTelefone(
                      instanciaInfo?.number ||
                      instanciaInfo?.owner ||
                      instanciaInfo?.instance?.number ||
                      instanciaInfo?.instance?.owner ||
                      telefoneBusca
                    )}

                    <br />

                    <strong>Nome perfil: </strong>
                    {instanciaInfo?.profileName ||
                      instanciaInfo?.instance?.profileName ||
                      '-'}

                    <br />

                    <strong>Status: </strong>
                    {status || 'connected'}
                  </div>
                </div>
              ) : qrCode ? (
                <div>
                  <Title level={4}>Escaneie o QR Code</Title>

                  <Text type="secondary">
                    Abra o WhatsApp, vá em aparelhos conectados e leia o QR Code.
                  </Text>

                  <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
                    {qrCode.startsWith('data:image') ? (
                      <Image
                        width={330}
                        height={330}
                        src={qrCode}
                        alt="QR Code WhatsApp"
                        preview={false}
                      />
                    ) : (
                      <QRCode
                        value={qrCode}
                        size={330}
                        status={loadingQR ? "loading" : "active"}
                      />
                    )}
                  </div>

                  <div style={{ marginTop: 16 }}>
                    <Tag color="orange">Aguardando leitura</Tag>
                    {status && <Tag>{status}</Tag>}
                  </div>
                </div>
              ) : (
                <div>
                  <Image
                    width={330}
                    height={330}
                    src={errorImage}
                    alt="Aguardando QR Code"
                    preview={false}
                  />

                  <div style={{ marginTop: 16 }}>
                    <Text type="secondary">
                      Informe o WhatsApp acima para buscar o QR Code.
                    </Text>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Card>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
`;

export default Mensageiro;